import React from 'react';
import classNames from 'classnames';
import Map from './Map';
import {MapControls} from './Map';
import Navigation from './Navigation';
import Languages from './Languages';
import Legend from './Legend';
import About from './About';
import Header from './Header';
import Homepage from './Homepage';
import Games from './Games';

const MAPBOX = 'pk.eyJ1Ijoiam9jYW1sIiwiYSI6Ijg2ZGZjNTY2MWQ3NjdlZmU3ODhiNzk1MTkwZDg2ZTQ2In0.DYFWbv_uv3DjGeKhmhfCng'

export default class Main extends React.Component {

  constructor (props) {
    super(props);
    this.getCategory = this.getCategory.bind(this);
    this.handleHomepageAdvertClick = this.handleHomepageAdvertClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.home_banners.length > 0) {
      if (nextProps.lang != null && this.props.lang == null) {
        document.getElementById('homebanners').style.display = 'none';
      }

      if (nextProps.lang == null && this.props.lang != null) {
        document.getElementById('homebanners').style.display = 'inherit';
      }
    }

    if (nextProps.selectedExtra != null) {
      document.getElementById('iframes').style.display = 'inherit';
      document.getElementById('extra-iframe-' + nextProps.selectedExtra).style.display = 'inherit';
    }

    if (this.props.selectedExtra != null &&
        this.props.selectedExtra !== nextProps.selectedExtra) {
      document.getElementById('iframes').style.display = 'none';
      document.getElementById('extra-iframe-' + this.props.selectedExtra).style.display = 'none';
    }

    if (nextProps.selectedGame != null) {
      document.getElementById('iframes').style.display = 'inherit';
      document.getElementById('game-iframe-' + nextProps.selectedGame).style.display = 'inherit';
    }

    if (this.props.selectedGame != null &&
        this.props.selectedGame !== nextProps.selectedGame) {
      document.getElementById('iframes').style.display = 'none';
      document.getElementById('game-iframe-' + this.props.selectedGame).style.display = 'none';
    }
  }

  render () {
    let category = null, header = null, poi = [], legend = null;

    let {lang, weather, sponsor, selectedExtra, gamesSelected} = this.props;
    let about = this.props.kiosk_group.about;

    if (this.props.category) {
      category = this.getCategory(this.props.category);
      poi = category.poi;
      legend = <Legend {...category}
                       lang={this.props.lang}
                       page={this.props.page}
                       selected={{
                         poi: this.props.selected_poi,
                         subcategory: this.props.subcategory,
                       }}
                       setPage={this.props.setPage}
                       selectPOI={this.props.selectPOI}
                       selectSubcategory={this.props.selectSubcategory} />;
      header = <Header {...{lang, category, sponsor}} poi={this.props.selected_poi} />
    }

    let map = <Map poi={poi}
       category={category}
       selectedExtra={selectedExtra}
       gamesSelected={this.props.gamesSelected}
       categories={this.props.categories}
       mapId="jocaml.1dd57872" accessToken={MAPBOX}
       active={this.props.selected_poi}
       subcategory={this.props.subcategory}
       onSelect={this.props.selectPOI}
       sponsor={sponsor}
       dimensions={this.getMapDimensions()}
       area={this.props.area}
       lang={lang}
       updateMap={this.props.updateMap}
       homeLocation={this.props.location.coordinates}
       {...this.props.map}
       className="map"
    />;

    let main = null;
    if (lang == null) {
      return (
        <div>
          <Homepage languages={this.props.languages}
                    title={this.props.kiosk_group.name}
                    advert={this.props.homepage_advert}
                    onAdvertClick={this.handleHomepageAdvertClick}
                    onSelectLanguage={this.props.selectLanguage} />
          { map }
        </div>
      );
    } else if (category == null && selectedExtra == null && !gamesSelected) {
      main = (
        <main>
          <About {...{lang, about, weather}} />
          <div id="info">
            { map }
          </div>
        </main>
      );
    } else if (selectedExtra != null) {
      main = (
        <main>
          <div style={{display: 'none'}}>{ map }</div>
        </main>
      )
    } else if (gamesSelected) {
      let games = null;
      if (this.props.selectedGame == null) {
        games = <Games games={this.props.games} onSelectGame={this.props.selectGame} />;
      }
      main = (
        <main>
          { games }
          <div style={{display: 'none'}}>{ map }</div>
        </main>
      )
    } else {
      if (category.legend_type === 'iframe') {
        main = (
          <main>
            <div id="info">
              { header }
              <div style={{display: 'none'}}>{ map }</div>
              <iframe title={category.name} src={category.url} sandbox='allow-scripts allow-same-origin ' />
            </div>
          </main>
        );
      } else {
        main = (
          <main>
            <div id="info">
              { header }
              { map }
              <MapControls map={this.props.map} updateMap={this.props.updateMap} />
              { legend }
            </div>
          </main>
        );
      }
    }

    const isCollapsed = category != null || selectedExtra != null || gamesSelected;
    let cls = {
      collapsed: isCollapsed,
      noncollapsed: !isCollapsed,
    };
    if (category != null) cls['category-' + category.css_class] = true;

    return (
      <div id="Main" className={classNames(cls)}>
        <nav>
          <h1>{ this.props.kiosk_group.name }</h1>
          <Navigation categories={this.props.categories}
                      extra={this.props.extra}
                      games={this.props.games}
                      games_svg_icon={this.props.games_svg_icon}
                      lang={this.props.lang}
                      onChange={this.props.selectCategory}
                      onSelectExtra={this.props.selectExtra}
                      onGameSelect={this.props.selectGame}
                      selectedExtra={selectedExtra}
                      gamesSelected={this.props.gamesSelected}
                      selected={this.props.category} />
          <Languages  languages={this.props.languages}
                      onChange={this.props.selectLanguage}
                      selected={this.props.lang} />
        </nav>
        { main }
      </div>
    );
  }

  handleHomepageAdvertClick() {
    const category_id = this.props.homepage_advert.open_poi_category_id;
    if (category_id != null) {
      this.props.selectLanguage('hr');
      this.props.selectCategory(category_id);
    }
  }

  getCategory(id) {
    return this.props.categories.find(cat => cat.poi_category_id === id);
  }

  getMapDimensions () {
    let props = this.props;
    if (window.LANDSCAPE) {
      let width = 1920, height = 1080, top = 0, left = 0;

      if (props.lang == null) {
        // pass
      } else if (props.category) {
        width = width - 1000;
        left = 1000;
        height = 1000;
        top = 80;
        if (props.sponsor && props.sponsor.footer_id) height = height - 360;
      } else {
        width = width - 400;
        left = 400;
      }

      return {width, height, top, left};
    } else {
      let width = 1080, height = 1920, top = 0, left = 0;

      if (props.lang == null) {
        // pass
      } else if (props.category) {
        let category = this.getCategory(props.category),
            infoHeight = category.info_height;
        width = width - 150;
        left = 150;
        height = height - infoHeight - 80;
        top = 80;
        if (props.sponsor && props.sponsor.footer_id) height = height - 360;
      } else {
        width = width - 400;
        left = 400;
      }

      return {width, height, top, left};
    }
  }
}

